/**
 * Model for OrderTerm collection
 */
export class OrderTermModel {
  public _id: string;

  // TODO find a better way then injecting service in a model constructor.
  constructor(
    uuid,
    public country: string = '',
    public language: string = '',
    public orderPreviewText1: string = '',
    public orderPreviewText2: string = '',
    public orderPreviewText3: string = '',
    public orderPreviewText4: string = '',
  ) {
    this._id = uuid.v4();
  }
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const OrderTermModelProvider = {
  provide: 'OrderTermModel',
  useValue: OrderTermModel,
};
